import React, { useCallback, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { AdminSidebar } from './AdminSidebar';

export const AdminLayout: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const hamburgerRef = useRef<HTMLButtonElement>(null);

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false);
    // Double rAF: first frame commits the re-render (removes `hidden` class
    // from the hamburger), second frame fires focus() on the now-visible
    // element. Single rAF can race with React's commit ordering and land on
    // a still-hidden target, where .focus() is a no-op.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => hamburgerRef.current?.focus());
    });
  }, []);

  return (
    <div className="h-dvh bg-neutral-950">
      <button
        ref={hamburgerRef}
        type="button"
        onClick={() => setIsDrawerOpen(true)}
        aria-label="Abrir menu admin"
        aria-expanded={isDrawerOpen}
        aria-controls="admin-drawer"
        className={`fixed top-4 left-4 z-50 p-3 rounded-xl bg-neutral-900/90 backdrop-blur-sm border border-white/10 text-white lg:hidden ${
          isDrawerOpen ? 'hidden' : ''
        }`}
      >
        <Menu className="w-5 h-5" />
      </button>

      <AdminSidebar isMobileOpen={isDrawerOpen} onMobileClose={closeDrawer} />

      <main className="h-dvh overflow-y-auto lg:ml-64">
        <div className="p-4 pt-20 lg:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
